import { Injectable } from '@angular/core';
import { SampleShipments, SelectOptions } from '@etoh/database/core';
import { sortBy } from 'lodash';
import { BehaviorSubject, Observable, filter, map, take } from 'rxjs';
import { AftershipService } from '../../aftership.service';
import { SampleshipmentCarriersOptions } from './sampleShipment.interface';

@Injectable({
  providedIn: 'root',
})
export class SampleShipmentsService {
  private allCarriersOptions$ = new BehaviorSubject<SelectOptions<any>[]>([]);
  get allCarriersOptions(): Observable<SelectOptions<any>[]> {
    return this.allCarriersOptions$.pipe(filter((r) => r.length > 0));
  }

  constructor(private aftershipService: AftershipService) {
    this.getSampleShipmentsCarrierForOptions$().pipe(take(1)).subscribe();
  }

  getSampleShipmentsCarrierForOptions$(
    sampleShipment: SampleShipments | null = null
  ): Observable<SelectOptions<any>[]> {
    return this.aftershipService.courriers$.pipe(
      map((courriers) => {
        return sortBy(
          courriers.couriers.map((courrier) => {
            return {
              label: courrier.name,
              value: courrier.slug,
            };
          }),
          'label'
        );
      }),
      map((courriers) => {
        const allCarriersOptions = [
          ...SampleshipmentCarriersOptions,
          ...courriers,
        ];
        this.allCarriersOptions$.next(allCarriersOptions);

        if (sampleShipment === null) {
          return allCarriersOptions;
        }

        if (sampleShipment?.isHardcodedCarrier) {
          return SampleshipmentCarriersOptions;
        }

        return courriers;
      })
    );
  }
}
